site.googleTranslate = Object.assign({
	autoDisplay: false,
	appendElementDesktop: '.qn__translate',
	appendElementMobile: '.mmLevel1.quickLinks',

	init: function() {
		let isDesktop = document.body.clientWidth + 15 >= 992;
		let gt = document.createElement('div');
		gt.setAttribute('id', 'google_translate_element');
		gt.setAttribute('class', (isDesktop ? 'hidden-sm hidden-xs' : 'hidden-lg hidden-md'));

		let target = isDesktop
			? site.googleTranslate.appendElementDesktop
			: site.googleTranslate.appendElementMobile;

		window.onload = function() {
			document.querySelector(target).appendChild(gt);
			new google.translate.TranslateElement({
				pageLanguage: document.documentElement.lang,
				layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
				autoDisplay: site.googleTranslate.autoDisplay,
			}, 'google_translate_element');
		};
	},
}, site.googleTranslate || {});
